var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.stage",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("stage")(item.stage)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }